"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the string constants you can use as HTML attributes for the <tableau-pulse> web component.
 * @ignore
 */
var PulseAttributes;
(function (PulseAttributes) {
    PulseAttributes["DisableExploreFilter"] = "disable-explore-filter";
    PulseAttributes["Layout"] = "layout";
})(PulseAttributes = exports.PulseAttributes || (exports.PulseAttributes = {}));
/**
 * The names of the string constants you can use as child tags for TableauPulse custom element.
 */
var PulseChildElements;
(function (PulseChildElements) {
    /**
     * Custom styles applicable to the embedded iframe element itself (not inside it).
     */
    PulseChildElements["IframeStyle"] = "iframe-style";
})(PulseChildElements = exports.PulseChildElements || (exports.PulseChildElements = {}));
//# sourceMappingURL=PulseInterfaces.js.map